export default {
  getZones: "getZones",
  removeZones: "removeZones",
  updateZones: "updateZones",
  addZones: "addZones",
  removeZone: "removeZone",
};
